import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=a1d1afb0&scoped=true&"
import script from "./UserManagement.vue?vue&type=script&lang=ts&"
export * from "./UserManagement.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=a1d1afb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d1afb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d1afb0')) {
      api.createRecord('a1d1afb0', component.options)
    } else {
      api.reload('a1d1afb0', component.options)
    }
    module.hot.accept("./UserManagement.vue?vue&type=template&id=a1d1afb0&scoped=true&", function () {
      api.rerender('a1d1afb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserManagement.vue"
export default component.exports